import React, { useState } from "react";

//ANT DESIGN IMPORTS
import {
    Input,
    Row,
    Form,
    Col,
    Divider,
    Table,
    Typography,
    Select,
    Button,
    Modal,
    Tooltip,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { EditOutlined } from "@ant-design/icons";

import { BOM } from "../../../../../../services/definedMethod";
import styles from "../../../../../../assets/styles/styles";
import { labelConfig } from "../../../../group.config";


const SettingsForm = (props) => {
    //DECLARED VARIABLES
    const {
        onFinish,
        form,
        userData,
        accountLinkingOptions,
        clientMembersData,
        setClientMembersData,
        loanPurposeOptions,
        rowSelection,
    } = props;
    const { session } = userData;
    const [selectedRow, setSelectedRow] = useState(null);

    const { Title } = Typography;

    const columns = [
        {
            title: "Client ID",
            dataIndex: "clientId",
        },
        {
            title: "Client Name",
            dataIndex: "clientName",
        },
        {
            title: "Loan Purpose",
            dataIndex: "loanPurposeId",
        },
        {
            title: "Original Loan",
            dataIndex: "originalLoan",
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (_, record) =>
                <EditClient
                    selectedRecord={record}
                    loanPurposeOptions={loanPurposeOptions}
                    clientMembersData={clientMembersData}
                    setClientMembersData={setClientMembersData}
                />
        },
    ];

    return (
        <Form form={form} layout="vertical" onFinish={onFinish}>
            <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {labelConfig.settingsInfo}
                </Title>
            </Divider>
            <Row>
                <Table
                    rowSelection={{
                        type: "checkbox",
                        ...rowSelection,
                    }}
                    columns={columns}
                    dataSource={clientMembersData}
                    bordered
                    pagination={{
                        position: "bottomCentre",
                    }}
                />
                <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.linkSavings}
                        name="linkAccountId"
                    >
                        <Select
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                )
                            }
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.linkSavings,
                                "select"
                            )}
                            options={accountLinkingOptions}
                            showSearch
                            allowClear
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};
export default SettingsForm;

const EditClient = (props) => {
    const {
        selectedRecord,
        clientMembersData,
        setClientMembersData,
        loanPurposeOptions,
    } = props;

    const [useForm] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        console.log(selectedRecord);

        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onSubmit = (values) => {

        values.key = selectedRecord?.key;
        if (values?.originalLoan === undefined) {
            delete values.originalLoan
        }
        values.loanPurposeId = loanPurposeOptions.find(
            item => item?.value === values?.loanPurposeId
        )?.label;

        const editedClientRecord = clientMembersData.map(item =>
            item.key === values.key ? { ...item, ...values } : item
        );
        setClientMembersData(editedClientRecord);
        setIsModalOpen(false);
    };

    return (
        <>
            <Tooltip title="Edit Client">
                <Button
                    type="primary"
                    icon={<EditOutlined />}
                    onClick={showModal}
                    shape="round"
                    size="small"
                    className="of-primaryBtnColor"
                />
            </Tooltip>
            <Modal
                title="Edit Loan Purpose and Original Loan"
                open={isModalOpen}
                okText="Submit"
                cancelText="Cancel"
                okButtonProps={{
                    autoFocus: true,
                    htmlType: "submit",
                    style: {
                        ...styles.ofPrimaryBtnColor,
                    },
                }}
                centered
                onCancel={handleCancel}
                width={800}
                modalRender={(dom) => (
                    <Form layout="vertical" form={useForm} onFinish={onSubmit}>
                        {dom}
                    </Form>
                )}
                style={{
                    height: 600,
                    overflow: "auto",
                }}
            >
                <Row>
                    <Col span={12} style={{ padding: "0px 8px" }}>
                        <Form.Item
                            name="loanPurposeId"
                            label={labelConfig.loanPurpose}
                        >
                            <Select
                                placeholder="Please select a value"
                                options={loanPurposeOptions}
                                showSearch
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12} style={{ padding: "0px 8px" }}>
                        <Form.Item
                            name="originalLoan"
                            label={labelConfig.originalLoan}
                        >
                            <Input
                                placeholder="Please Enter a Value"
                            />
                        </Form.Item>
                    </Col>
                </Row>

            </Modal>
        </>
    );
};
